import React, { useState } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';

import Base from './base';
import BaseWithERP from './baseWithERP';
import { scale } from '@components/frame';
import { toBase64 } from '@helpers';
import { SmallLoading } from '@components/loading';

const Pdf = ({ source }) => {
  return <embed src={source.uri} width="87px" height="57px" style={{ zIndex: 100 }} />;
};
const ProductionInformation = (props) => {
  const { isWithERP } = props;
  const [selectedImages, setImages] = useState([]);

  const uploadImage = async (image) => {
    if (!image || !image.name) {
      return;
    }

    const uri = await toBase64(image);

    setImages([...selectedImages, { file: image, id: image.name, uri, fileName: image.name }]);
  };

  const deleteImage = (fileName) => {
    const newImages = selectedImages.filter((i) => i.fileName !== fileName);
    setImages(newImages);
  };

  if (typeof isWithERP !== 'boolean') {
    return (
      <View style={{ width: '100%', minHeight: scale(790), justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <SmallLoading />
      </View>
    );
  }

  if (isWithERP) {
    return <BaseWithERP {...props} />;
  }

  return <Base {...{ ...props, Pdf, selectedImages, deleteImage, uploadImage }} />;
};

const mapStateToProps = ({ membership: { isWithERP } }) => ({ isWithERP });

export default connect(mapStateToProps, {})(ProductionInformation);
